module.exports = __webpack_public_path__ + "711eda2a.svg";